import { Typography, Hidden } from '@mui/material';
import Grid from 'components/core/Grid';
import { listClientHappyImage } from 'config/imageUrls';

import { ContentSection, StyledBulletList } from './styles';
export const ClientsLoveAllura = () => {
  return (
    <>
      <ContentSection>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Typography variant="h2" mb={2}>
              Why Clients Love alluraDirect
            </Typography>
            <Typography>
              Our focus on mountain resort destinations has given us the advantage of understanding the communities,
              businesses and people that make everything great. The global corporations simply cannot achieve this same
              level of personal connection.
            </Typography>
            <StyledBulletList>
              <li>Proudly Canadian owned/operated and not just a faceless global corporation.</li>
              <li>Personalized support direct from our team and not from an offshore call center.</li>
              <li>Specific experience, products and services dedicated to mountain resort destinations.</li>
            </StyledBulletList>
            <Typography mb={2}>
              For most vacation rentals, the reality is there is more guest demand than there is inventory available.
              Knowing what each hosting platform values and if they do or do not operate by the rules (allowing illegal
              rentals), is a defining factor in the long-term success of your rental property and community.
            </Typography>
            <Typography>We ski your mountain. We hike the same trails. We want to be part of your success.</Typography>
          </Grid>
          <Hidden only="sm">
            <Grid item xs={12} md={4}>
              <img src={listClientHappyImage} width="100%" />
            </Grid>
          </Hidden>
        </Grid>
      </ContentSection>
    </>
  );
};
